import type { Metadata } from "next";
import urlJoin from "url-join";

import type { ComponentSeoAlternateHreflang, ComponentSharedSeo } from "@Shared/api";
import { BASE_LOCALE_URLS, DEFAULT_LOCALE } from "@Shared/config";
import { DEFAULT_LANGUAGE } from "@Shared/i18n";

import { getImageSrcFromApiData } from "./image-src";

export const getSeoFromApiData = (seoData?: ComponentSharedSeo | null, path: string = ""): Metadata => {
    const seoObj: Metadata = {};

    if (seoData?.metaTitle) {
        seoObj.title = seoData.metaTitle;
    }

    if (seoData?.metaDescription) {
        seoObj.description = seoData.metaDescription;
    }

    if (seoData?.keywords) {
        seoObj.keywords = seoData.keywords;
    }

    if (seoData?.metaRobots) {
        seoObj.robots = seoData.metaRobots;
    }

    if (seoData?.metaImage?.data) {
        seoObj.openGraph = {
            images: getImageSrcFromApiData(seoData.metaImage.data?.attributes),
        };
    }

    if (seoData?.canonicalURL) {
        seoObj.alternates = {
            ...seoObj.alternates,
            canonical: seoData.canonicalURL === "null" ? null : seoData.canonicalURL,
        };
    } else {
        seoObj.alternates = {
            ...seoObj.alternates,
            canonical: urlJoin(BASE_LOCALE_URLS[DEFAULT_LANGUAGE as "en"], path),
        };
    }

    if (seoData?.hreflang?.length) {
        seoObj.alternates = {
            ...seoObj.alternates,
            languages: seoData.hreflang.reduce(
                (acc, item) => {
                    if (item.href !== "null") {
                        acc[item.lang] = item.href;
                    }

                    return acc;
                },
                {} as Record<ComponentSeoAlternateHreflang["lang"], string>
            ),
        };
    } else {
        seoObj.alternates = {
            ...seoObj.alternates,
            languages: Object.entries(BASE_LOCALE_URLS).reduce(
                (acc, [lang, url]) => {
                    acc[lang as ComponentSeoAlternateHreflang["lang"]] = urlJoin(url, path);

                    return acc;
                },
                {} as Record<ComponentSeoAlternateHreflang["lang"], string>
            ),
        };
    }

    return seoObj;
};
